// ─── Specs Accordion — Variant-Aware Content ──────────────────────────────────
// On variant change, swaps the visible specs content to the selected variant's
// metafield HTML (data-specs-variant). Falls back to the default metafield
// content (data-specs-default) if no variant-specific specs are set.

(function () {
  const productForm = document.querySelector('form[id^="product-form"]');
  if (!productForm) return;

  // ─── Specs ──────────────────────────────────────────────────────────────────

  function updateSpecs(variantId) {
    const defaultEl = document.querySelector('[data-specs-default]');
    if (!defaultEl) return;

    const variantEl = document.querySelector(`[data-specs-variant="${variantId}"]`);

    if (variantEl) {
      defaultEl.hidden = true;
      document.querySelectorAll('[data-specs-variant]').forEach(el => {
        el.hidden = el !== variantEl;
      });
    } else {
      defaultEl.hidden = false;
      document.querySelectorAll('[data-specs-variant]').forEach(el => {
        el.hidden = true;
      });
    }
  }

  // ─── FAQ ────────────────────────────────────────────────────────────────────
  // Finds the FAQ accordion matching the variant metafield's title and swaps
  // its answer. Restores the original answer when switching to a variant
  // with no override.

  function updateFaq(variantId) {
    const overrideEl = document.querySelector(`[data-faq-variant="${variantId}"]`);

    if (overrideEl) {
      const matchTitle = overrideEl.dataset.faqMatchTitle;
      const accordion = document.querySelector(`[data-faq-title="${CSS.escape(matchTitle)}"]`);
      if (!accordion) return;

      const answerEl = accordion.querySelector('[data-faq-answer]');
      if (!answerEl) return;

      // Store original answer once so we can restore it later
      if (!answerEl.hasAttribute('data-faq-original')) {
        answerEl.setAttribute('data-faq-original', answerEl.innerHTML);
      }
      answerEl.innerHTML = overrideEl.innerHTML;
    } else {
      // No override for this variant — restore any previously swapped answers
      document.querySelectorAll('[data-faq-answer][data-faq-original]').forEach(el => {
        el.innerHTML = el.getAttribute('data-faq-original');
        el.removeAttribute('data-faq-original');
      });
    }
  }

  // ─── Vest Mode Titles ───────────────────────────────────────────────────────
  // Updates each .ns-vest-modes__mode-title text based on the variant's
  // Variant Vest Modes Title metafield (list of single text, one per card).

  function updateVestModeTitles(variantId) {
    const overrideEl = document.querySelector(`[data-vest-mode-variant="${variantId}"]`);
    const titleEls = document.querySelectorAll('[data-vest-mode-title]');
    if (!titleEls.length) return;

    if (overrideEl) {
      const spans = overrideEl.querySelectorAll('span');
      titleEls.forEach(el => {
        const index = parseInt(el.dataset.vestModeTitle, 10);
        if (spans[index] === undefined) return;
        // Store original text once for restoration
        if (!el.hasAttribute('data-vest-mode-original')) {
          el.setAttribute('data-vest-mode-original', el.textContent);
        }
        el.textContent = spans[index].textContent;
      });
    } else {
      // No override — restore originals
      titleEls.forEach(el => {
        if (el.hasAttribute('data-vest-mode-original')) {
          el.textContent = el.getAttribute('data-vest-mode-original');
          el.removeAttribute('data-vest-mode-original');
        }
      });
    }
  }

  // ─── Event listeners ────────────────────────────────────────────────────────

  productForm.addEventListener('variant:change', (event) => {
    if (!event.detail.variant) return;
    const id = event.detail.variant.id;
    updateSpecs(id);
    updateFaq(id);
    updateVestModeTitles(id);
  });

  // Set correct state on page load for the initially selected variant
  const initialVariantInput = productForm.querySelector('[name="id"]');
  if (initialVariantInput?.value) {
    updateSpecs(initialVariantInput.value);
    updateFaq(initialVariantInput.value);
    updateVestModeTitles(initialVariantInput.value);
  }
})();
